export default __webpack_public_path__ + "static/imxapps_rest-46e41791e875fb8b85c23e857e050782.png";